import PerimetrosTab from '@/components/PerimetrosTab';

export default function PerimetrosPage() {
  return (
    <div className="fade-in" data-testid="perimetros-page">
      <div className="mb-5">
        <h2 className="font-heading font-medium text-xl text-brand-text">Os meus perímetros</h2>
        <p className="text-xs text-brand-muted mt-1">Regista as tuas medições e acompanha a tua evolução</p>
      </div>
      <PerimetrosTab patientId={null} />
    </div>
  );
}
